export default __webpack_public_path__ + "static/media/hero-meditation.505799f4.png";